import { useState } from 'react';
import { Button, Grid, Box, Typography, Alert, } from '@mui/material';
import {  formToJson} from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { MyTextField } from '../../../Component/MuiEx';
const EditTerm = (props) => {
    const {data,onSubmit,onClose} = props
    const [fieldErrors, setFieldErrors] = useState()    
    const [error, setError] = useState()
    // const session = getUserSession(apis)

    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id:0
        onSubmit && onSubmit(postData,setError,setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Term</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <MyTextField type="text" required={true} fieldErrors={fieldErrors} defaultValue={data?.name} id="name" fullWidth={true} label="Term Name"/>                            
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextField type="date" fieldErrors={fieldErrors} defaultValue={data?.begin} id="begin_date" fullWidth={true} label="Begin date"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextField type="date" fieldErrors={fieldErrors} defaultValue={data?.end} id="end_date" fullWidth={true} label="End date"/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MyTextField multiline={true} fieldErrors={fieldErrors} defaultValue={data?.description} id="description" fullWidth={true} label="Description"/>
                        </Grid>  

                    </Grid>

                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                </Box>
            </Box>
        </Container>
    );
}
export default EditTerm